import { motion } from "motion/react";
import { cn } from "@/core/helpers/cn";

type Props = {
  isPulse: boolean;
  className?: string;
};

const animateVariants = {
  alive: {
    strokeDasharray: "870 870",
    opacity: 1,
    transition: { duration: 1, repeatDelay: 1, repeat: Infinity, ease: [0.17, 0.67, 0.83, 1] },
  },
  death: {
    strokeDasharray: "870 870",
    opacity: 1,
    transition: { duration: 5, ease: "easeInOut" },
  },
};

export default function DeathScreenСardiogram({ isPulse, className }: Props) {
  return (
    <div
      key={`cardiogram-${isPulse ? "alive" : "death"}`}
      className={cn(
        "relative [mask-image:linear-gradient(90deg,transparent,black,transparent)]",
        className,
      )}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="504"
        height="80"
        viewBox="0 0 504 80"
        fill="none"
      >
        <g>
          <path
            d="M0 46.0215H65.4205C65.7789 46.0215 66.1099 45.8297 66.2881 45.5187L82.5378 17.1628C82.9415 16.4585 83.9719 16.5032 84.313 17.2399L105.066 62.0688C105.428 62.8512 106.545 62.8392 106.89 62.0491L132.802 2.74177C133.187 1.86188 134.47 1.97685 134.691 2.91106L152.284 76.9835C152.508 77.9282 153.811 78.0311 154.181 77.1334L166.745 46.6406C166.899 46.266 167.264 46.0215 167.67 46.0215H205.605C205.859 46.0215 206.103 45.9249 206.288 45.7513L227.768 25.6323C228.172 25.2538 228.806 25.2757 229.183 25.6811L257.365 55.9839C257.879 56.5367 258.797 56.3423 259.043 55.6285L273.653 13.2128C273.951 12.3467 275.16 12.3042 275.518 13.1471L289.241 45.4129C289.398 45.7819 289.76 46.0215 290.161 46.0215H327.129C327.368 46.0215 327.6 46.1073 327.781 46.2634L339.54 56.3782C340.03 56.7996 340.784 56.6527 341.081 56.0785L369.134 1.6789C369.502 0.96539 370.518 0.954464 370.902 1.6599L394.716 45.4988C394.891 45.821 395.228 46.0215 395.595 46.0215H429.988C430.31 46.0215 430.611 46.176 430.799 46.4366L453.733 78.2434C454.232 78.9352 455.313 78.7251 455.516 77.8967L468.313 25.7081C468.423 25.2608 468.824 24.9462 469.284 24.9462H504"
            stroke="url(#paint0_linear_1234_7252)"
            strokeWidth="4"
            opacity={0.2}
          />
          <motion.path
            initial={{ strokeDasharray: "0 870", opacity: 0.4 }}
            variants={animateVariants}
            animate={isPulse ? "alive" : "death"}
            d="M0 46.0215H65.4205C65.7789 46.0215 66.1099 45.8297 66.2881 45.5187L82.5378 17.1628C82.9415 16.4585 83.9719 16.5032 84.313 17.2399L105.066 62.0688C105.428 62.8512 106.545 62.8392 106.89 62.0491L132.802 2.74177C133.187 1.86188 134.47 1.97685 134.691 2.91106L152.284 76.9835C152.508 77.9282 153.811 78.0311 154.181 77.1334L166.745 46.6406C166.899 46.266 167.264 46.0215 167.67 46.0215H205.605C205.859 46.0215 206.103 45.9249 206.288 45.7513L227.768 25.6323C228.172 25.2538 228.806 25.2757 229.183 25.6811L257.365 55.9839C257.879 56.5367 258.797 56.3423 259.043 55.6285L273.653 13.2128C273.951 12.3467 275.16 12.3042 275.518 13.1471L289.241 45.4129C289.398 45.7819 289.76 46.0215 290.161 46.0215H327.129C327.368 46.0215 327.6 46.1073 327.781 46.2634L339.54 56.3782C340.03 56.7996 340.784 56.6527 341.081 56.0785L369.134 1.6789C369.502 0.96539 370.518 0.954464 370.902 1.6599L394.716 45.4988C394.891 45.821 395.228 46.0215 395.595 46.0215H429.988C430.31 46.0215 430.611 46.176 430.799 46.4366L453.733 78.2434C454.232 78.9352 455.313 78.7251 455.516 77.8967L468.313 25.7081C468.423 25.2608 468.824 24.9462 469.284 24.9462H504"
            strokeWidth="4"
            stroke="#FF3838"
            strokeDasharray="870 800"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_1234_7252"
            x1="252"
            y1="80"
            x2="252"
            y2="0"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0.2" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}
